import React from 'react';
import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';
import useCountryTable from './hooks/useCountryTable';

const TabCountry = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    setColumns,
    columns,
    newRecord,
    spinning,
    postData,
    createNewRecord,
    handleUpdateRows,
    onListRender,
    resetNewRecord,
    dataSource,
    handleClearFilter,
    handleDeleteRows,
  } = useCountryTable();

  return (
    <>
      {spinning && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource || []}
            onListRender={onListRender}
            columns={columns}
            setColumns={setColumns}
            autocompleteFieldProvider={autocompleteFieldSearch}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortModelChange}
            scroll={{ y: '60vh', x: '90vw' }}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='country-table'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            total
            showAutoIncrement
            handleUpdateRows={handleUpdateRows}
            onDeleteClick={handleDeleteRows}
            newRecord={newRecord}
            postData={postData}
            saveNewRecord={createNewRecord}
            resetNewRecord={resetNewRecord}
            clearFilter={handleClearFilter}
            activeOnSelectRowsDisableEdit
            columnFilterShown
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};
export default TabCountry;
